// extracted by mini-css-extract-plugin
export default {"emptyMessage":"emptyMessage---em2qL"};